import { styled } from '@mui/material';

import Background from '../../../../assets/image/background.png';
export const AuthLayoutStyled = styled('div')(({ theme }) => ({
  backgroundColor: theme.palette.dark.dark_2,
  height: '100vh',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  backgroundImage: `url(${Background})`,
  backgroundRepeat: 'no-repeat',
  backgroundSize: 'cover',
}));
